import {formattPrice} from './utils'
enum SelectType {
  RADIO = "radio",
  CHECKBOX = "checkbox",
}

const mulltyAdd = {
  addTocart: document.querySelectorAll(
    ".jsAddToCart"
  ) as NodeListOf<HTMLElement>,
  dummyBtn: document.querySelectorAll(
    ".jsDummyAddToCart"
  ) as NodeListOf<HTMLElement>,
  multyBuyForm: document.getElementById("multyBuy") as HTMLElement | undefined,
  priceHtml: document.getElementById("prodPrice") as HTMLElement | undefined,
  radioBtnsWrap: document.querySelectorAll(
    ".jsRadioInputWrap"
  ) as NodeListOf<HTMLElement>,
  radioBtns: document.querySelectorAll(
    ".jsRadioBtn"
  ) as NodeListOf<HTMLElement>,
  prodPriceSticky: document.getElementById("prodPriceSticky") as
    | HTMLElement
    | undefined,
  currentPrice: 0,
  qty: 0,
  sum: 0,
  minQty: 0,
  prodTitle: document.querySelectorAll(
    ".jsProdTitle"
  ) as NodeListOf<HTMLElement>,
  prodSubtitle: document.getElementById("prodSubtitle") as
  | HTMLElement
  | undefined,
  prodSku: document.getElementById("prodSku") as
  | HTMLElement
  | undefined,
  init() {
    if (this.multyBuyForm) {
      this.addListeners();
      this.setMainPrice();
      this.addResetLisitener()
    }else{
      this.setMainPrice();
    }
  },
  addResetLisitener() {
        window.addEventListener("resetQty", () => {
          this.addListeners(false);
    });
  },
  updateInfo(item:HTMLElement){
      if(this.prodSku){
        this.prodSku.innerText = item.dataset.sku || ''
      }
      if(this.prodSubtitle){
        this.prodSubtitle.innerText = item.dataset.subtitle || ''
      }
      this.prodTitle.forEach(el => el.innerHTML = item.dataset.name || '')
  },
  setMainPrice() {
    if(!this.prodPriceSticky || !this.priceHtml) return
    const price = this.priceHtml!.dataset.price as string;
    this.currentPrice = +price;
    this.prodPriceSticky.innerHTML = this.priceHtml.innerHTML;

  },

  resetAll() {
    this.qty = 0;
    this.sum = 0;
    const price = formattPrice(+this.currentPrice.toFixed(2));
    this.priceHtml!.innerHTML = price;
    this.prodPriceSticky!.innerHTML = price;
    this.resetElements(this.radioBtns);
  },
  setPrice() {
    if (this.validateQty()) {
      this.addTocart.forEach((item) => item.classList.remove("d-none"));
      this.dummyBtn.forEach((item) => item.classList.add("d-none"));
    } else {
      this.addTocart.forEach((item) => item.classList.add("d-none"));
      this.dummyBtn.forEach((item) => item.classList.remove("d-none"));
    }
    const price = formattPrice(+(this.sum + this.currentPrice).toFixed(2));
    this.priceHtml!.innerHTML = price;
    this.prodPriceSticky!.innerHTML = price;
  },
  calcPrice() {
    this.qty = 0;
    this.sum = 0;
    this.radioBtns.forEach((item) => {
      if (item.dataset.selected === "true") {
        const min = item.dataset.min ? item.dataset.min : "1";
        const price = item.dataset.price as string;
        this.qty++;
        this.sum += +price * +min;
      }
    });
  },
  resetElements(items: NodeListOf<HTMLElement>) {
    items.forEach((item) => {
      const input = item.querySelector(".jsRadioInput") as HTMLInputElement;
      item.dataset.selected = "false";
      item.classList.remove("activeClass");
      input.value = "0";
    });
  },
  validateQty(): boolean {
    let valid = true;
    for (let i = 0; i < this.radioBtnsWrap.length; i++) {
      if (this.radioBtnsWrap[i].dataset.valid === "false") {
        valid = false;
        break;
      }
    }
    return valid;
  }, 
  addListeners(addEvent = true) {
    this.radioBtnsWrap.forEach((item) => {
      const inputs = item.querySelectorAll(
        ".jsRadioBtn"
      ) as NodeListOf<HTMLElement>;
      const type = item.dataset.type as string;
      const info = item.dataset.info  as string;
      const minElements = item.dataset.min ? item.dataset.min : 0;
      const maxElements =
        !item.dataset.max && type === SelectType.RADIO ? 1 : item.dataset.max;
      let selected = 0;

      if (+minElements === 1) {
        const sortedItems = [...inputs].sort((a, b) => {
          const price1 = a.dataset.price as string
          const price2 = b.dataset.price as string
          return +price1 - +price2

      });
        const input = sortedItems[0].querySelector(
          ".jsRadioInput"
        ) as HTMLInputElement;
        const min = sortedItems[0].dataset.min ? sortedItems[0].dataset.min : "1";
        this.resetElements(inputs);
        selected = 1;
        sortedItems[0].dataset.selected = "true";
        sortedItems[0].classList.add("activeClass");
        input.value = min;
        if(info === 'true'){
          this.updateInfo(sortedItems[0])
        }
        this.calcPrice();
        this.setPrice();
      }
      item.dataset.valid =
        +minElements === 0 || +minElements === selected ? "true" : "false";
        if(addEvent){
          inputs.forEach((el) => {
            const input = el.querySelector(".jsRadioInput") as HTMLInputElement;
            const min = el.dataset.min ? el.dataset.min : "1";
            el.addEventListener("click", () => {
              if (el.dataset.selected === "true" && type === SelectType.CHECKBOX) {
                selected--;
                el.dataset.selected = "false";
                el.classList.remove("activeClass");
                input.value = "0";
              } else {
                selected++;
                if (maxElements && +maxElements <= selected) {
                  this.resetElements(inputs);
                  selected = 1;
                }
                if(info === 'true'){
                  this.updateInfo(el)
                }
                el.dataset.selected = "true";
                el.classList.add("activeClass");
                input.value = min;
              }
              item.dataset.valid =
                +minElements === 0 || +minElements === selected ? "true" : "false";
    
              this.calcPrice();
              this.setPrice();
            });
          });
        }
     
    });
  },
};

export default mulltyAdd;
